export const ActionCodes = Object.freeze({
    IndividualUpdateFares: 'UPDATE_FARES',
    BulkUpdateFares: 'BULK_UPDATE_FARES',
});
